import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";

export class CheckboxView {

  removeEventHandlers = [];
  removeListenerFunctions = [];

  constructor(config = {}) {
    var options = $.extend(
      true,
      {
        itemClass: "item",
        toggleButtonClass: "toggleButton",
        selectAllClass: "selectAll",
      },
      config
    );
    this.id = options.id; //this is used as the id for the list of checkboxes
    this.itemsId = options.itemsId; //these need to be overriden
    this.toggleButtonClass = options.toggleButtonClass;
    this.selectAllClass = options.selectAllClass;
    //this.dataFieldName = options.dataFieldName;//TODO does this make sense to be in here?//move to basesubview
    this.selectAllContainerId = options.selectAllContainerId || this.id; //these need to be overriden
    this.itemClass = options.itemClass; //again what is this used for?

    this.addListener(LS2PAC_CONSTANTS.Events.onLogoutResponse, () => {
      this.uncheckSelectAll();
    });
    //problem this.id may not contain the select all nor toggleButtons
  }

  addListener(eventString, callback) {
    const guid = TLCEventManager.addListener(eventString, callback);
    this.removeListenerFunctions.push(() => TLCEventManager.removeListener(eventString, guid));
  }
  addEventHandler(jQueryElement, events, selector, handler) {
    jQueryElement.on(events, selector, handler);
    this.removeEventHandlers.push(() => jQueryElement.off(events, selector))
  }
  cleanup(){
    // remove events
    this.removeEventHandlers.forEach((remove) => remove());
    // remove listeners
    this.removeListenerFunctions.forEach((remove) => remove());
  }

  //finds the index of the data array based on the DOM position
  getItemIndex(element) {
    return $("#" + this.id)
      .find("." + this.itemClass)
      .index(element.parents("." + this.itemClass));
  }
  //gets the object from the array based on index
  getDataItemFromIndex(element) {
    return this.pageData[this.dataFieldName][this.getItemIndex(element)]; //TODO this seems too specific for the base class//move to base sub view and prompt to override
  }
  //can either call this or delegate however you want
  setupCheckboxDelegation() {
    var _this = this;
    this.addEventHandler($("#" + this.selectAllContainerId), "change", "." + this.selectAllClass, (event) => {
      var container = $(event.currentTarget).attr("data-itemContainer");
      //data-itemContainer should = this.id
      this.setAllCheckboxes(event.currentTarget.checked, container);
    });
    this.addEventHandler($("#" + this.id), "change", "input:checkbox", (event) => {
      this.onClickRowCheckbox(event.currentTarget);
    });
  }
  
  setAllCheckboxes(isChecked, contextId) {
    //require a target container...
    $("#" + (contextId || this.id))
      .find("input:checkbox")
      .each(function (index, checkbox) {
        checkbox.checked = isChecked;
      });
    //$("#" + _this.id).find("." + TlcTbt.constants.CssClasses.selectRow).attr('checked', this.checked);
    this.toggleButtonsBasedOnCheckboxes();
  }
  uncheckSelectAll() {
    $("#" + this.selectAllContainerId)
      .find("." + this.selectAllClass)
      .each(function (index, element) {
        element.checked = false;
      });
  }
  onClickRowCheckbox(checkbox) {
    if (checkbox.checked !== true) {
      this.uncheckSelectAll();
    }
    this.toggleButtonsBasedOnCheckboxes();
  }
  //find the objects for the corresponding checked elements
  getSelectedItems() {
    var _this = this,
      selectedItems = [];
    $("#" + _this.itemsId)
      .find("input:checked")
      .each(function (index, checkbox) {
        if ($(checkbox).is(":visible")) {
          // We don't want hidden checkboxes
          selectedItems.push(_this.getDataItemFromIndex($(checkbox)));
        }
      });
    return selectedItems;
  }
  /* handles turning the action buttons on or off depending on if elements are selected */
  toggleButtonsBasedOnCheckboxes() {
    var _this = this;
    //this timeout is silly but we have to wait for the UI to update when you un-select all
    setTimeout(function () {
      if ($("#" + _this.id).find("input:checked").length === 0) {
        //TODO this should be context based... you can deselect all the checkboxes except select all and this will trigger incorrectly
        //TODO also need to uncheck the check all in this case
        $("#" + _this.id)
          .find("." + _this.toggleButtonClass)
          .addClass(LS2PAC_CONSTANTS.CssClasses.disabled)
          .prop("disabled", true);
        $("#" + _this.id).find(".batchControls").addClass(LS2PAC_CONSTANTS.CssClasses.disabled);
      } else {
        $("#" + _this.id)
          .find("." + _this.toggleButtonClass)
          .removeClass(LS2PAC_CONSTANTS.CssClasses.disabled)
          .prop("disabled", false);
        $("#" + _this.id).find(".batchControls").removeClass(LS2PAC_CONSTANTS.CssClasses.disabled);
      }

      $("#" + _this.id)
        .find("input:checkbox")
        .each(function (index, checkbox) {
          if (checkbox.checked) {
            //TODO may be more efficient to do this on the row click handler...
            $(checkbox).parents(".item").addClass("hilite");
          } else {
            $(checkbox).parents(".item").removeClass("hilite");
          }
        });
    }, 150);
  }
}
